import { Input } from 'antd'
import { faAt, faBriefcase, faIdCard, faPhone, faUser } from '@fortawesome/pro-solid-svg-icons'

import FormItem from '../../../../Components/shared/Forms/FormItem'
import { Properties } from '../../../../utils/entities'
import { PortalCoordinator } from '../../../../utils/entities/schoolPortalRequest'

const { EMAIL, FIRST_NAME, JOB_TITLE, LAST_NAME, PHONE } = Properties

const CoordinatorForm = ({ errorFields = [], data, emailDisabled = false, onChange }) => {
  const handleEventChange = key => e => onChange(new PortalCoordinator({ ...data, [key]: e.target.value }))

  const className = field => errorFields.includes(field) ? 'error-ant-border' : ''

  return (
    <div className='pd-12'>
      <FormItem icon={faAt} label='common.contact_email.dd' required>
        <Input
          className={className(EMAIL)}
          disabled={emailDisabled}
          value={data[EMAIL] ?? null}
          onChange={handleEventChange(EMAIL)}
        />
      </FormItem>
      <div className='responsive-flex-row'>
        <div className='responsive-w-50'>
          <FormItem icon={faIdCard} label='common.first_name.dd' required>
            <Input
              className={className(FIRST_NAME)}
              value={data[FIRST_NAME] ?? null}
              onChange={handleEventChange(FIRST_NAME)}
            />
          </FormItem>
        </div>
        <div className='responsive-w-50 responsive-ml-20'>
          <FormItem icon={faUser} label='common.last_name.dd' required>
            <Input
              className={className(LAST_NAME)}
              value={data[LAST_NAME] ?? null}
              onChange={handleEventChange(LAST_NAME)}
            />
          </FormItem>
        </div>
      </div>
      <FormItem
        icon={faBriefcase}
        label='school_portal.coordinator.job_title.dd'
        required
      >
        <Input
          className={className(JOB_TITLE)}
          value={data[JOB_TITLE] ?? null}
          onChange={handleEventChange(JOB_TITLE)}
        />
      </FormItem>
      <FormItem icon={faPhone} label='common.phone_number.dd'>
        <Input
          className={className(PHONE)}
          value={data[PHONE] ?? null}
          onChange={handleEventChange(PHONE)}
        />
      </FormItem>
    </div>
  )
}

export default CoordinatorForm
